/**
 * Web Vitals Reporting Module
 * 
 * This module provides functionality for measuring and reporting Core Web Vitals
 * which are important metrics for understanding the user experience of the website.
 * 
 * These metrics include:
 * - CLS (Cumulative Layout Shift): measures visual stability
 * - FID (First Input Delay): measures interactivity
 * - FCP (First Contentful Paint): measures perceived load speed
 * - LCP (Largest Contentful Paint): measures loading performance
 * - TTFB (Time to First Byte): measures initial server response time
 */

import { ReportHandler } from 'web-vitals';

/**
 * Reports web vitals metrics to a specified handler function
 * 
 * @param onPerfEntry - Optional callback function to handle performance entries
 */
const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  // Only proceed if a valid callback function is provided
  if (onPerfEntry && onPerfEntry instanceof Function) {
    // Dynamically import web-vitals to reduce initial bundle size
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      // Register each web vital metric with the provided callback
      getCLS(onPerfEntry);  // Cumulative Layout Shift
      getFID(onPerfEntry);  // First Input Delay
      getFCP(onPerfEntry);  // First Contentful Paint
      getLCP(onPerfEntry);  // Largest Contentful Paint
      getTTFB(onPerfEntry); // Time To First Byte
    });
  }
};

export default reportWebVitals;
